import styled from 'styled-components';
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  span {
    color: ${({ theme }) => theme.palette.white} !important;
  }
`;

export const ChatBox = styled.div`
  flex: 1;
`;
